import intermind from '../../../index';

export class RoomResource {
  async create(): Promise<string> {
    const { data } = await intermind.httpClient.post<{ id: string }>('/rooms');
    return data?.id;
  }
}
